<div class="container">
    <h1 class="principal-title">Redes de observatorios</h1>
    <div class="principal-summary">
        <ng-container *ngIf="t1?.summary">{{t1.summary}}</ng-container>
    </div>
    <br>
    <div class="row justify-content-center mb-3">
        <div class="col-sm-4">
            <div class="input-group">
                <input type="text" id="searchInput" class="form-control select-custom" placeholder="Buscar"
                    #searchInputRef>
                <div class="input-group-append">
                    <button class="btn search-button" (click)="performSearch(searchInputRef.value)">
                        <i class="fa fa-search" style="color: aliceblue;"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class=" col-sm-4">
            <select class="form-select select-custom" id="select-ambito" #selectTipo
                (change)="selectedTipoChanged(selectTipo.value)">
                <option selected class="select-items" value="0">Tipo</option>
                <option class="select-items" *ngFor=" let tip of tipo" [value]="tip.name">
                    {{tip.name}}
                </option>
            </select>
        </div>
        <div class=" col-sm-4">
            <select class="form-select select-custom" id="select-tematic" #selectTematic
                (change)="selectedTematicChanged(selectTematic.value)">
                <option selected class="select-items" value="0">Temática</option>
                <option class="select-items" *ngFor="let tematic of tematic" [value]="tematic.id">
                    {{tematic.title}}
                </option>
            </select>
        </div>
    </div>
    <div *ngIf="showResultsMessage">
        <p>Resultados encontrados</p>
    </div>
    <ng-container>
        <div *ngIf="showNoResultsMessage">
            <p>No se encontraron resultados.</p>
        </div>
    </ng-container>
    <ng-container *ngIf="!showNoResultsMessage">
        <div class="container main-container">
            <div class="row">
                <div class="col-md-4 "
                    *ngFor="let o of observers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)">
                    <a class="a-others" href="{{o.url}}" target="_blank">
                        <div>
                            <div>
                                <img class="img-fluid img-others" src="{{URLObs}}{{o.urlimage}}" alt="{{o.name}}">
                            </div>
                            <div class="title">
                                <b>{{o.name}}</b>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </ng-container>
    <br>
    <div class="form-group row">
        <div class="col-sm-12">
            <!-- Agregar controles de paginación -->
            <nav aria-label="Page navigation">
                <ul class="pagination">
                    <li class="page-item" *ngFor="let pageNumber of getPageNumbers()">
                        <a class="page-link" href="javascript:void(0);" [class.page-number]="true"
                            [class.active]="isPageActive(pageNumber)" (click)="changePage(pageNumber)">
                            {{ pageNumber }}
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div>